export const PolicyTypes = [
  "TODAY_MORNING",
  "TODAY_EVENING",
  "TODAY_OVERNIGHT",
  "TOGETHER",
  "SME",
  "FORWARDING",
] as const

export type PolicyType = (typeof PolicyTypes)[number]

// LMTE  :: TO-Day 당일
// LMTM :: TO-Day 익일
// LMSME :: 인천 SME
// LMTG ::  B2B 합짐
export const PolicyTypeToRouteNameMap: Record<PolicyType, string> = {
  TODAY_MORNING: "LMTM",
  TODAY_EVENING: "LMTE",
  TODAY_OVERNIGHT: "",
  SME: "LMSME",
  TOGETHER: "LMTG",
  FORWARDING: "",
}
